import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  tagRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacings.sm,
    marginTop: theme.spacings.md,
  },
  tagInfo: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
    gap: theme.spacings.sm,
    marginRight: theme.spacings.md,
  },
  tagInput: {
    width: 350,
    marginBottom: 0,
  },
  tagActions: {
    flexDirection: 'row',
    gap: theme.spacings.md,
  },
  patientCount: {
    color: theme.colors.newUI.therapist.grey70,
    fontSize: theme.fontSizes.sm,
  },
});
